/**
 * The type of (redux) action which signals the user has interacted with the
 * page.
 *
 * {
 *     type: USER_INTERACTION_RECEIVED,
 * }.
 */
export const USER_INTERACTION_RECEIVED = 'USER_INTERACTION_RECEIVED';
